import { Button, ChevronRightSVG, Icon } from "@newsela/angelou";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { Assignment } from "@/types/models";
import {
  buttonCss,
  buttonDetailsCss,
  iconCss,
} from "./GeniusAssignmentOption.style";

interface GeniusAssignmentOptionProps {
  assignment: Assignment;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

const GeniusAssignmentOption = ({
  assignment,
  onClick,
}: GeniusAssignmentOptionProps) => {
  const hasClassrooms = assignment.assignment_classrooms?.length > 0;

  const teacherText = `Teacher: ${assignment.created_by?.user?.display_name}`;
  const classText = hasClassrooms
    ? `Class: ${assignment?.assignment_classrooms?.[0]?.classroom?.name}`
    : "";

  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.incognito}
      __cssFor={{
        root: buttonCss,
      }}
      onClick={onClick}
      dataProps={{
        "data-qa-selector": `generation-genius-assignment-option`,
      }}
      ariaProps={{
        "aria-label": `${assignment.title}. ${teacherText}. ${classText}. Open assignment activity panel`,
      }}
      objectType={objectTypes.content}
      actionName={actionNames.navigate}
    >
      <div css={buttonDetailsCss}>
        <div>{assignment.title}</div>
        <div>{teacherText}</div>
        {hasClassrooms ? classText : null}
      </div>
      <Icon
        __cssFor={{ root: iconCss }}
        SvgComponent={ChevronRightSVG}
        size={Icon.sizes.md}
      />
    </ButtonWithTrackEvent>
  );
};

export default GeniusAssignmentOption;
